import React from 'react'
import { Button } from 'react-bootstrap'

type SideMenuButtonProps = {
    isActive: boolean
    onClick: () => void
    iconClass: string
    disabled?: boolean
}

const SideMenuButton: React.FC<SideMenuButtonProps> = ({
    isActive,
    onClick,
    iconClass,
    disabled
}) => {
    return (
        <Button className={`${isActive ? 'active' : ''}`} onClick={onClick} disabled={disabled}>
            <i className={iconClass}></i>
        </Button>
    )
}

export default SideMenuButton
